import React from "react";
import { hot } from "react-hot-loader";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import getStore from "./utils/getStore";
import FaqPage from "components/site/page/FaqPage";

function FaqRoot() {
    return (
        <Provider store={getStore()}>
            <React.Fragment>
                <FaqPage />
                <ToastContainer />
            </React.Fragment>
        </Provider>
    );
}

if (DEVELOPMENT) {
    FaqRoot = hot(module)(FaqRoot);
}

export default FaqRoot;
